(function($, Drupal) {
  'use strict';

  Drupal.behaviors.cookie_repostion = {
    attach: function(context, settings) {
      $(document).ready(function() {
        const $skip_to_content = $('#skip-to-content');
        const $cookie_consent = $('#sliding-popup');
        if ($cookie_consent.length !== 0) {
          $skip_to_content.after($cookie_consent);
        }
      });
    }
  };
})(jQuery, Drupal);
